import { getActionTypeFromInstance, NGXS_PLUGINS } from "@ngxs/store";

import { Logout, authStateDefaults } from "@fitscovery/auth/data-access";
import { userStateDefaults } from "@fitscovery/user/data-access";
import { partnerStateDefaults } from "@fitscovery/partner/data-access";

import { accountStoreDefaults } from '@fitscovery/account-web/shared/store';

function accountWebLogoutPlugin(state: any, action: any, next: any) {

  if (getActionTypeFromInstance(action) === Logout.type) {
    state = {
      auth: authStateDefaults,
      user: userStateDefaults,
      partner: partnerStateDefaults,

      app: accountStoreDefaults,
      router: state.router,
      shared: state.shared
    };
  }

  return next(state, action);
}

export const AccountWebLogoutPluginProvider = {
  provide: NGXS_PLUGINS,
  useValue: accountWebLogoutPlugin,
  multi: true
};
